// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/img/SB-Icons/copy.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("@/assets/img/SB-Icons/copy-hover.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, ".copy-number[data-v-62d30de2]{cursor:pointer;margin-left:3px;display:block;width:16px;height:10px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-position:50%}.copy-number[data-v-62d30de2]:hover{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}.copy-number.big-copy[data-v-62d30de2]{width:20px;height:12px}", ""]);
// Exports
module.exports = exports;
